import React, { Component, PropTypes } from 'react';

class List extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { children, ...other } = this.props;
    return <div {...other}>{children}</div>;
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/js/components/List/List.js